import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { 
  User, 
  Mail, 
  Building, 
  Briefcase, 
  FileText, 
  Lock, 
  CheckCircle, 
  AlertCircle,
  RefreshCw,
  ArrowLeft
} from 'lucide-react';
import NavbarComptable from '../components/NavbarComptable';
import SidebarComptable from '../components/SidebarComptable';

const CreateClient = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [notification, setNotification] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    entreprise: "",
    secteur: "",
    registre_commerce: "",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError("");
  };

  const generatePassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%";
    let password = "";
    for (let i = 0; i < 12; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setFormData({ ...formData, password });
    showNotification("Mot de passe généré avec succès", "success");
  };

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        "https://api-ec.cinef-expertises.com/api/clients",
        formData
      );

      setSuccess(true);
      showNotification("Client créé avec succès !", "success");
      
      // Redirection après 3 secondes
      setTimeout(() => {
        navigate("/dashboard-comptable/echeances");
      }, 3000);
      
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || "Une erreur est survenue");
      } else {
        setError("Erreur de connexion au serveur");
      }
      showNotification(err.response?.data?.message || "Erreur lors de la création", "error");
      setLoading(false);
    }
  };

  if (success) {
    return (
      <>
        <div className="app-container">
          <SidebarComptable
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
          />

          <div className="main-wrapper">
           <NavbarComptable
            selectedClient={selectedClient}
            onClientChange={setSelectedClient}
         
           />

            <main className="main-content">
              <div className="success-page">
                <div className="success-card">
                  <div className="success-icon">
                    <CheckCircle size={64} />
                  </div>
                  <h2>Client créé avec succès !</h2>
                  <p>Un email contenant les identifiants a été envoyé au client.</p>
                  <p className="redirect-text">Redirection en cours...</p>
                </div>
              </div>
            </main>
          </div>
        </div>

        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          .app-container {
            display: flex;
            height: 100vh;
            background: linear-gradient(135deg, #f8fafb 0%, #f1f5f9 100%);
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          }

          .main-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-left: 280px;
          }

          .main-content {
            flex: 1;
            padding: 32px;
            overflow-y: auto;
            max-width: calc(100vw - 280px);
            box-sizing: border-box;
          }

          .success-page {
            min-height: calc(100vh - 180px);
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .success-card {
            background: white;
            padding: 60px;
            border-radius: 20px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
            text-align: center;
            max-width: 500px;
            animation: slideUp 0.5s ease;
          }

          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .success-icon {
            color: #10b981;
            display: flex;
            justify-content: center;
            margin-bottom: 24px;
            animation: scaleIn 0.6s ease;
          }

          @keyframes scaleIn {
            from {
              transform: scale(0);
            }
            to {
              transform: scale(1);
            }
          }

          .success-card h2 {
            color: #1e293b;
            font-size: 28px;
            margin-bottom: 16px;
            font-weight: 700;
          }

          .success-card p {
            color: #64748b;
            font-size: 16px;
            line-height: 1.6;
          }

          .redirect-text {
            margin-top: 24px;
            color: #dc3545;
            font-weight: 600;
            font-size: 14px;
          }

          @media (max-width: 1023px) {
            .main-wrapper {
              margin-left: 0;
            }
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className="app-container">
        <SidebarComptable
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <div className="main-wrapper">
          <NavbarComptable />

          <main className="main-content">
            {/* Notification */}
            {notification && (
              <div className={`notification ${notification.type}`}>
                {notification.type === 'success' ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
                <span>{notification.message}</span>
              </div>
            )}

            {/* Header Section */}
            <div className="page-header">
              {/* <button 
                className="btn-back"
                onClick={() => navigate("/dashboard-comptable/echeances")}
              >
                <ArrowLeft size={18} />
                <span>Retour</span>
              </button> */}

              <div className="header-content">
                <div className="header-text">
                  <h1 className="page-title">Créer un nouveau client</h1>
                  <p className="page-subtitle">
                    Remplissez le formulaire pour créer un compte client. Un email contenant les identifiants sera automatiquement envoyé.
                  </p>
                </div>
              </div>
            </div>

            {/* Form Card */}
            <div className="form-container">
              <div className="form-card">
                <div className="form-header">
                  <h2 className="form-title">Informations du client</h2>
                  <p className="form-subtitle">
                    Les champs marqués d'un * sont obligatoires
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-grid">
                    {/* Nom */}
                    <div className="form-group">
                      <label>
                        <User size={16} />
                        <span>Nom</span>
                      </label>
                      <input
                        type="text"
                        name="nom"
                        className="form-control"
                        placeholder="Nom du client"
                        value={formData.nom}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Prénom */}
                    <div className="form-group">
                      <label>
                        <User size={16} />
                        <span>Prénom</span>
                      </label>
                      <input
                        type="text"
                        name="prenom"
                        className="form-control"
                        placeholder="Prénom du client"
                        value={formData.prenom}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Email */}
                    <div className="form-group full-width">
                      <label>
                        <Mail size={16} />
                        <span>Email *</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="email@exemple.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Entreprise */}
                    <div className="form-group full-width">
                      <label>
                        <Building size={16} />
                        <span>Entreprise</span>
                      </label>
                      <input
                        type="text"
                        name="entreprise"
                        className="form-control"
                        placeholder="Nom de l'entreprise"
                        value={formData.entreprise}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Secteur d'activité */}
                    <div className="form-group">
                      <label>
                        <Briefcase size={16} />
                        <span>Secteur d'activité</span>
                      </label>
                      <input
                        type="text"
                        name="secteur"
                        className="form-control"
                        placeholder="Ex: Commerce, Services..."
                        value={formData.secteur}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Registre de commerce */}
                    <div className="form-group">
                      <label>
                        <FileText size={16} />
                        <span>Registre de commerce</span>
                      </label>
                      <input
                        type="text"
                        name="registre_commerce"
                        className="form-control"
                        placeholder="Numéro RC"
                        value={formData.registre_commerce}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Mot de passe */}
                    <div className="form-group full-width">
                      <label>
                        <Lock size={16} />
                        <span>Mot de passe *</span>
                      </label>
                      <div className="password-input-wrapper">
                        <input
                          type="text"
                          name="password"
                          className="form-control"
                          placeholder="Mot de passe temporaire"
                          value={formData.password}
                          onChange={handleChange}
                          required
                        />
                        <button
                          type="button"
                          className="btn-generate"
                          onClick={generatePassword}
                          title="Générer un mot de passe"
                        >
                          <RefreshCw size={16} />
                          <span>Générer</span>
                        </button>
                      </div>
                      <small className="form-text">
                        Ce mot de passe sera envoyé par email au client
                      </small>
                    </div>
                  </div>

                  {error && (
                    <div className="alert alert-danger">
                      <AlertCircle size={18} />
                      <span>{error}</span>
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="btn-submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <RefreshCw size={18} className="spinning" />
                        <span>Création en cours...</span>
                      </>
                    ) : (
                      <>
                        <CheckCircle size={18} />
                        <span>Créer le client</span>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </main>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .app-container {
          display: flex;
          height: 100vh;
          background: linear-gradient(135deg, #f8fafb 0%, #f1f5f9 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .main-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 320px;
        }

        .main-content {
          flex: 1;
          padding: 32px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: rgba(220, 53, 69, 0.3) transparent;
        }

        .main-content::-webkit-scrollbar {
          width: 6px;
        }

        .main-content::-webkit-scrollbar-thumb {
          background: rgba(220, 53, 69, 0.2);
          border-radius: 10px;
        }

        /* Notification */
        .notification {
          position: fixed;
          top: 100px;
          right: 24px;
          z-index: 1000;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 24px;
          border-radius: 12px;
          background: white;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          font-weight: 600;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from { transform: translateX(400px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        .notification.success {
          border-left: 4px solid #10b981;
          color: #059669;
        }

        .notification.error {
          border-left: 4px solid #dc3545;
          color: #b91c1c;
        }

        /* Header */
        .page-header {
          margin-bottom: 32px;
        }

        .btn-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: white;
          border: 1px solid #d1d5db;
          color: #64748b;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-bottom: 20px;
        }

        .btn-back:hover {
          background: #f8fafb;
          border-color: #dc3545;
          color: #dc3545;
          transform: translateX(-2px);
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .page-title {
          font-size: 32px;
          font-weight: 700;
          margin: 0 0 8px 0;
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }

        .page-subtitle {
          color: #64748b;
          margin: 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 1.5;
        }

        /* Form Container */
        .form-container {
          max-width: 900px;
          margin: 0 auto;
        }

        .form-card {
          background: white;
          padding: 40px;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .form-header {
          margin-bottom: 32px;
        }

        .form-title {
          font-size: 24px;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 8px 0;
        }

        .form-subtitle {
          color: #64748b;
          font-size: 14px;
          margin: 0;
        }

        /* Form Grid */
        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group.full-width {
          grid-column: 1 / -1;
        }

        .form-group label {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #1e293b;
          font-weight: 600;
          font-size: 14px;
        }

        .form-control {
          width: 100%;
          padding: 14px 16px;
          border: 2px solid #e8ecf1;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.3s ease;
          background: #f8f9fa;
          color: #1e293b;
          font-family: inherit;
        }

        .form-control:focus {
          outline: none;
          border-color: #dc3545;
          background: white;
          box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.1);
        }

        .form-control::placeholder {
          color: #94a3b8;
        }

        /* Password Input */
        .password-input-wrapper {
          display: flex;
          gap: 12px;
        }

        .password-input-wrapper .form-control {
          flex: 1;
        }

        .btn-generate {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 14px 24px;
          background: linear-gradient(135deg, #6366f1, #4f46e5);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          white-space: nowrap;
        }

        .btn-generate:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(99, 102, 241, 0.3);
        }

        .form-text {
          display: block;
          margin-top: 8px;
          color: #64748b;
          font-size: 12px;
        }

        /* Alert */
        .alert {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 20px;
          border-radius: 12px;
          margin-bottom: 24px;
          margin-top: 24px;
          font-size: 14px;
          font-weight: 500;
        }

        .alert-danger {
          background: rgba(220, 53, 69, 0.1);
          color: #dc3545;
          border-left: 4px solid #dc3545;
        }

        /* Submit Button */
        .btn-submit {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 16px;
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
          margin-top: 32px;
        }

        .btn-submit:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
        }

        .btn-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .spinning {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Responsive */
        @media (max-width: 1023px) {
          .main-wrapper {
            margin-left: 0;
          }

          .main-content {
            padding: 20px;
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 16px;
          }

          .page-title {
            font-size: 24px;
          }

          .form-card {
            padding: 28px 20px;
          }

          .form-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .form-group.full-width {
            grid-column: 1;
          }

          .password-input-wrapper {
            flex-direction: column;
          }

          .btn-generate {
            width: 100%;
            justify-content: center;
          }

          .form-title {
            font-size: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default CreateClient;